/**
 * Persistent Logger for Pre-Deployment Debugging
 * Saves logs to localStorage so they survive page reloads.
 */

const LOG_KEY = 'debug_persistent_logs';
const MAX_LOGS = 100;

function saveLog(entry) {
    try {
        const logs = JSON.parse(localStorage.getItem(LOG_KEY) || '[]');
        logs.push(entry);
        if (logs.length > MAX_LOGS) {
            logs.shift();
        }
        localStorage.setItem(LOG_KEY, JSON.stringify(logs));
    } catch (e) {
        console.error('Failed to save persistent log', e);
    }
}

export const logger = {
    log: (component, message, data = null) => {
        const entry = {
            timestamp: new Date().toISOString(),
            level: 'INFO',
            component,
            message,
            data
        };
        saveLog(entry);
        console.log(`[${component}] ${message}`, data || '');
    },

    warn: (component, message, data = null) => {
        const entry = {
            timestamp: new Date().toISOString(),
            level: 'WARN',
            component,
            message,
            data
        };
        saveLog(entry);
        console.warn(`[${component}] ${message}`, data || '');
    },

    error: (component, message, error = null) => {
        const entry = {
            timestamp: new Date().toISOString(),
            level: 'ERROR',
            component,
            message,
            error: error ? { message: error.message, stack: error.stack } : null
        };
        saveLog(entry);
        console.error(`[${component}] ${message}`, error || '');
    },

    getLogs: () => {
        try {
            return JSON.parse(localStorage.getItem(LOG_KEY) || '[]');
        } catch (e) {
            return [];
        }
    },

    clearLogs: () => {
        localStorage.removeItem(LOG_KEY);
    }
};
